import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	OnChanges,
	OnDestroy,
	SimpleChanges
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { VgStates } from './VgStates';
import { VideogularComponent } from './Videogular.Component';

import { userAgentUtil } from 'vbrick-player-src/UserAgentUtil';
import styles from './VbMediaClick.Directive.module.less';

@Directive({
	selector: '[vb-media-click]',
	host: {
		'[class]': 'isSmallSizePlayer ? styles.smallSizePlayer : ""'
	}
})
export class VbMediaClickDirective implements OnChanges, OnDestroy {
	@Input() public controlsSurfaced$: Observable<boolean>;
	@Input() public isControlsDisabled: boolean;
	@Input() public isInitialPlay: boolean;
	@Input() public isSmallSizePlayer: boolean;
	@Input() public is360Enabled: boolean;
	@Input() public overlayControlsVisible: boolean;


	public readonly styles = styles;

	private isTouch: boolean;
	private element: HTMLElement;
	private subscription: Subscription;
	private isControlsSurfaced: boolean;

	constructor(
		elementRef: ElementRef,
		private vgApi: VideogularComponent
	) {
		this.element = elementRef.nativeElement;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.isInitialPlay || changes.overlayControlsVisible) {
			this.addPrimaryPlayerOverlay();
			this.element.classList.toggle(styles.wholePrimaryPlayerOverlay, this.isInitialPlay || this.overlayControlsVisible);
		}

		if (changes.is360Enabled) {
			this.element.classList.toggle(styles.is360, this.is360Enabled);
		}

		if (changes.controlsSurfaced$ && this.controlsSurfaced$) {
			this.subscribeControlSurface();
		}
	}

	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	/**
	 * Workaround for Mac Firefox not dispatching the expected mouseup event on the Flash <object>.
	 */
	@HostListener('click', ['$event'])
	private onClick($event: MouseEvent): void {
		if (userAgentUtil.isFirefoxMac && ($event.target as HTMLElement).tagName === 'OBJECT') {
			this.onMouseUp($event);
		}
	}

	@HostListener('mouseup', ['$event'])
	private onMouseUp($event: MouseEvent): void {
		const is360: boolean = this.vgApi.activeSource.is360Enabled; // clashes with 360 drag behavior
		const isNotPrimaryMouseButton: boolean = $event.which > 1;

		if (isNotPrimaryMouseButton || is360) {
			return;
		}

		// ignore if triggered from touch
		if (this.isTouch) {
			this.isTouch = false;
			return;
		}

		this.pauseOrStop();
	}

	@HostListener('touchstart', ['$event'])
	private onTouch($event: TouchEvent): void {
		this.isTouch = true;

		if (this.isControlsSurfaced) {
			// prevent mouse events from being generated
			$event.preventDefault();

			this.pauseOrStop();
		}
	}

	private pauseOrStop(): void {
		if (!this.isControlsDisabled && this.vgApi.currentState === VgStates.PLAY) {
			this.vgApi.activeSource.isLive ?
				this.vgApi.stop() :
				this.vgApi.pause();
		}
	}

	private subscribeControlSurface(): void {
		this.subscription = this.controlsSurfaced$.subscribe(surfaced => {
			this.isControlsSurfaced = surfaced;
			this.addPrimaryPlayerOverlay();
			this.element.classList.toggle(styles.controlBarOverlay, this.isControlsSurfaced);
		});
	}

	private addPrimaryPlayerOverlay(): void {
		this.element.classList.toggle(styles.primaryPlayerOverlay, this.isControlsSurfaced || this.isInitialPlay || this.overlayControlsVisible);
	}
}
